import { render, staticRenderFns } from "./CallEditComment.vue?vue&type=template&id=72223556"
import script from "./CallEditComment.vue?vue&type=script&lang=js"
export * from "./CallEditComment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports